import axiosInstance from "./AxiosInstance";

export function getStockTransactionsList(pagination = true, pageid = 0, search_by = "", search_keyword = "", sort_by = "", sort_order = "") {
  return axiosInstance.post("/stock/transactionList", { pagination, pageid, search_by, search_keyword, sort_by, sort_order });
}